<template>
  <el-container id="glDevSonSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-main style="background: #FFFFFF;">
      <div
          style="display:flex;height:36px;width:100%;line-height:0.3;margin-top:15px;text-align:left;align-items: center;">
          <span style="margin-left:6px; color:#ffffff; font-size: 13px">
              <el-select v-model="edi_build" ref='select'
                         clearable filterable placeholder="选择楼栋"
                         style="width:10vw;margin-left:5px">
                <el-option
                    v-for="item in li_build"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="edi_floor" ref='select'
                         clearable filterable placeholder="选择楼层"
                         style="width:10vw;margin-left:5px">
                <el-option
                    v-for="item in fil_li_floor"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="edi_room" ref='select'
                         clearable filterable placeholder="选择房间"
                         style="width:10vw;margin-left:5px">
                <el-option
                    v-for="item in fil_li_room"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
          </span>
      </div>
      <div style="margin-left:0;margin-top:10px;display:flex;height:80vh">
        <div style="width:auto;height:100%; margin-left:10px; margin-top:10px;">
          <el-transfer
              filterable
              class="my_transfer_gs"
              :titles="['设备列表', '选中列表']"
              :filter-method="filterMethod"
              filter-placeholder="请输入设备名称"
              v-model="xz_id"
              @mouseover.native="addTitle"
              :data="fil_tab">
          </el-transfer>
          <div style="text-align:right;margin-top:20px">
            <el-button @click="dialog_Onclick('退出')">退出
            </el-button>
            <el-button type="primary" @click="dialog_Onclick('保存')"
                       style="margin-left:20px">保存
            </el-button>
          </div>
        </div>
        <!--        <div style="width:400px; margin-left:50px; margin-top:10px;">-->
        <!--          <div style="display:flex;width:100%;margin-left:0px;margin-bottom:20px">-->
        <!--            <span style="margin-top:16px;">组合名称：</span>-->
        <!--            <el-input style="width:10vw;margin-left:2px;margin-top:6px;"-->
        <!--                      :min="0" v-model="dev_name">-->
        <!--            </el-input>-->
        <!--          </div>-->
        <!--          <div style="display:flex;width:100%;margin-left:0px;margin-bottom:20px">-->
        <!--            <span style="margin-top:16px;">设备DID：</span>-->
        <!--            <el-input style="width:10vw;margin-left:5px;margin-top:6px;"-->
        <!--                      :min="0" v-model="dev_did">-->
        <!--            </el-input>-->
        <!--          </div>-->
        <!--          <el-button @click="dialog_Onclick('退出')">退出-->
        <!--          </el-button>-->
        <!--          <el-button type="primary" @click="dialog_Onclick('保存')"-->
        <!--                     style="margin-left:130px">保存-->
        <!--          </el-button>-->
        <!--        </div>-->
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name:"glDevSonSon",
  data() {
    return {
      h_text:"新增雷达",
      li_h_text:[
        {"text":"管理设置","colour":"#B7B7B7","pages":""},
        {"text":"雷达列表","colour":"#B7B7B7","pages":""}
      ],
      d_type:"update",
      dev_did:"",
      dev_name:"",
      xz_id:[],
      tab_data:[],
      edi_build:"",
      edi_floor:"",
      edi_room:"",
      li_build:[],
      li_floor:[],
      li_room:[],
      dev_type:"1",
      filterMethod(query,item) { // 筛选过滤
        return item.label.indexOf(query) > - 1;
      }
    };
  },
  methods:{ /*方法存放*/
    addTitle(e) {
      let target_el = e.target;
      if (target_el.title) return;
      target_el.title = target_el.innerText;
    },
    dialog_Onclick(v) {
      let l_d = [];
      switch (v) {
        case "保存":
          for (let i = 0; i < this.li_dev.length; i ++) {
            if (this.xz_id.indexOf(this.li_dev[i]["did"]) !== - 1) {
              l_d.push({
                'did':this.li_dev[i]["did"],
                'pid':this.li_dev[i]["pid"],
                'projectId':localStorage.getItem("projectId")
              });
            }
          }
          if (this.d_type === 'add') {
            this.add_db(l_d);
          } else {
            this.change_db(l_d);
          }
          break;
        case "退出":
          this.$router.go(- 1);
          break;
      }
    },
    add_db(l_d) {
      const params = {
        "did":"zhld111",
        "pid":'pir_gather',
        "VGroupDevice":l_d,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addDevToVGroup,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(- 1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加失败");
        }
      });
    },
    change_db(l_d) {
      const params = {
        "did":this.did,
        "pid":this.pid,
        "VGroupDevice":l_d,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateVGroupDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(- 1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    init_view() { /*初始化公司设备名称*/
      let data = [];
      for (let i = 0; i < this.li_dev.length; i ++) {
        const dev = this.li_dev[i];
        if (dev['isVirtual']) {
          continue;
        }
        let d = {
          key:dev['did'],
          did:dev['did'],
          pid:dev['pid'],
          label:`${dev['name']}`,
          roomId:dev['roomId']
        };
        if (dev['roomId']) {
          d['floorId'] = dev['room']['floorId'];
          if (!this.li_room.some(item => item.value === dev['roomId'])) {
            this.li_room.push({
              floorId:d['floorId'],
              value:dev['roomId'],
              label:dev['room']['name']
            });
          }
          d.label = dev['room']['floor']['name'] + "/" + dev['room']['name'] + "/" + dev['name'];
          if (dev['room']['floor']) {
            d['buildId'] = dev['room']['floor']['buildingId'];
            d['buildingName'] = dev['room']['floor']['building']['name'];
            d.label = dev['room']['floor']['building']['name'] + "/" + dev['room']['floor']['name'] + "/" + dev['room']['name'] + "/" + dev['name'];
            if (!this.li_build.some(item => item.value === d['buildId'])) {
              this.li_build.push({
                value:d['buildId'],
                label:d['buildingName']
              });
            }
            if (!this.li_floor.some(item => item.value === d['floorId'])) {
              this.li_floor.push({
                buildId:d['buildId'],
                value:d['floorId'],
                label:dev['room']['floor']['name']
              });
            }
          }
        } else if (dev['floorId']) {
          d['floorId'] = dev['floorId'];
          d.label = dev['floor']['name'] + "/" + dev['name'];
          if (dev['floor']) {
            d['buildId'] = dev['floor']['buildingId'];
            d['buildingName'] = dev['floor']['building']['name'];
            d.label = dev['floor']['building']['name'] + "/" + dev['floor']['name'] + "/" + dev['name'];
            if (!this.li_build.some(item => item.value === d['buildId'])) {
              this.li_build.push({
                value:d['buildId'],
                label:d['buildingName']
              });
            }
            if (!this.li_floor.some(item => item.value === d['floorId'])) {
              this.li_floor.push({
                buildId:d['buildId'],
                value:d['floorId'],
                label:dev['floor']['name']
              });
            }
          }
        }
        data.push(d);
      }
      console.log("设备列表",data);
      console.log("楼栋列表",this.li_build);
      console.log("楼层列表",this.li_floor);
      console.log("房间列表",this.li_room);
      this.tab_data = data;
    },
    get_dev() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        "virtualType":this.dev_type, // 1 - 人体存在传感器类，2 - 温湿度传感器类 3 - 空气质量传感器类
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getVGroupDeviceList,params,headers).then(res => {
        console.log("所有设备状态",res.data.data);
        this.total = res.data.data["total"];
        this.li_dev = res.data.data["list"];
        this.init_view();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    const value = this.$route.query.key;
    if (value === "addDev") {
      this.h_text = "新增组合";
      this.d_type = "add";
      this.dev_type = parseInt(this.$route.query.dev_type);
    } else {
      this.h_text = "修改设备信息";
      this.d_type = "update";
      this.dev_type = parseInt(this.$route.query.dev_type);
      this.did = this.$route.query.did;
      this.pid = this.$route.query.pid;
      this.xz_id = this.$route.query.li_son_dev;
    }
    this.get_dev();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tab() {
      return this.tab_data.filter(item => {
        let re_val = true;
        if (this.edi_build && item.buildId !== this.edi_build) {
          re_val = false;
        }
        if (this.edi_floor && item.floorId !== this.edi_floor) {
          re_val = false;
        }
        if (this.edi_room && item.roomId !== this.edi_room) {
          re_val = false;
        }
        return re_val;
      });
    },
    fil_li_floor() {
      return this.li_floor.filter(item => {
        return !(this.edi_build && item.value !== this.edi_build);
      });
    },
    fil_li_room() {
      return this.li_room.filter(item => {
        return !(this.edi_floor && item.value !== this.edi_floor);
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#glDevSonSon {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0;
  background: #F4F4F4;
}

.my_transfer_gs .el-transfer-panel {
  width: 18vw; /* 左右两个穿梭框的高度和宽度 */
  min-height: 55vh;
  max-height: 60vh;
}

.my_transfer_gs .el-transfer-panel__list.is-filterable {
  overflow-y: auto;
  height: calc(60vh - 150px) !important; /*去除表格底部留白*/
}

::-webkit-scrollbar { /*滑动条样式*/
  width: 8px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #0dA7C8;
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glDevSonSon.vue